import {delivery} from "@/api/delivery";
import {retryRequest} from "@/helpers/request";

export default {
    namespaced: true,
    state: {
        hide: null,
        items: [],
    },
    getters: {
        items: state => state.items.filter(item => !item._id || item._id != state.hide)
    },
    mutations: {
        setItems: (state, items) => state.items = items,
    },
    actions: {
        fetch: context => retryRequest(() => delivery.get("/banners")).then(
            response => {
                const items = [];

                response.data.results.forEach((item) => items.push({
                    id: item._id,
                    message: item.message["en-US"] ?? "",
                    lang_overrides: Object.keys(item.message).reduce(
                        (result, locale) => ({
                            ...result,
                            [locale]: {
                                message: item.message[locale]
                            }
                        }),
                        {}
                    )
                }));

                context.commit("setItems", items)
            }
        ),
        clear: context => context.commit("setItems", [])
    }
}